import React, { Component } from "react";
import { I18n } from "react-i18next";
import "../utils/i18n";
import "./Detail.css";
import { withRouter } from "react-router-dom";

class DetailStandort extends Component {
  static defaultProps = {
    spanSizeTitle: "span2",
    spanSizeText: "span6",
    spanSizeTotal: "span8"
  };
  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <div>
            <div className="row">
              <div
                className={`${
                  this.props.spanSizeTotal
                } detail-space-top-element`}
              >
                <strong>{t("detail.Standort")}</strong>
              </div>
            </div>
            <div className="row">
              <div
                className={`${
                  this.props.spanSizeTitle
                } text-right detail-space-top-element`}
              >
                {t("detail.Ort")}
              </div>
              <div className={`${this.props.spanSizeText} formfeld`}>
                {this.props.standort.ort}
              </div>
            </div>
            <div className="row">
              <div
                className={`${
                  this.props.spanSizeTitle
                } text-right detail-space-top-element`}
              >
                {" "}
                {t("detail.Kanton")}
              </div>
              <div className={`${this.props.spanSizeText} formfeld`}>
                {this.props.standort.kanton}
              </div>
            </div>
            <div className="row">
              <div
                className={`${
                  this.props.spanSizeTitle
                } text-right detail-space-top-element`}
              >
                {" "}
                {t("detail.Gebaude")}
              </div>
              <div className={`${this.props.spanSizeText} formfeld`}>
                {this.props.standort.gebaeude}
              </div>
            </div>
            <div className="row">
              <div
                className={`${
                  this.props.spanSizeTitle
                } text-right detail-space-top-element`}
              >
                {" "}
                {t("detail.Gebaudeteil")}
              </div>
              <div className={`${this.props.spanSizeText} formfeld`}>
                {this.props.standort.gebaeudeteil}
              </div>
            </div>
          </div>
        )}
      </I18n>
    );
  }
}

export default withRouter(DetailStandort);



// WEBPACK FOOTER //
// ./src/detail/DetailStandort.js